"use strict";

angular.module('app').filter('localeCompareString',function(){
    return function (items, field) {
        items.sort(function (a, b) {
            return a[field].localeCompare(b[field]);
        });
        return items;
      }; 
})